export enum TaskSortTypes {
    AppointmentDate = 'Appointment Date',
    TaskType = 'Task Type',
}
